import type { EntryPoint } from '@/apilib';
import { EditorAPIKey } from '@/apis';
import { createPinModeApi } from './pinModeWrapper';
import { PinModeApiKey } from './publicApiKey';

export const PinModeEntrypoint: EntryPoint = {
  name: 'PinModeApi',
  declareAPIs: () => [PinModeApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(PinModeApiKey, () => createPinModeApi(shell));
  },
};
